module.exports = __webpack_public_path__ + "static/media/thanks-for-your-request.8a285d66.svg";